function init () {
    const term = document.currentScript.getAttribute('title');
    const option = document.currentScript.getAttribute('option');

    loadResults (option, term);
}

function render (selected, options) {
  const content = options.map (({ term, url }) => `<div class="${selected == term ? 'selected' : ''} option-value"><a href="${url}" class="option-value-name">${term}</a></div>`).join ('');

  const optionValuesEl = document.querySelector ('#color-select .option-values');
  if (optionValuesEl) optionValuesEl.innerHTML = content;
}

function loadResults (selected, term) {
  $.ajax({
    url: `/search?type=product&q=title:"${term}"`,
    cache: false,
    data: `view=color-selector`,
    dataType: "html",
    headers: { "cache-control": "no-cache" },
    success: function (response) {
        const data = JSON.parse (response);
        
        const options = data.results.map (({ url, vendor, title }) => ({ term: vendor, url, title })).filter(({ title }) => title === term);
        render (selected, options);
    },
    error: function () {
        console.log ('error')
    },
})
}

init ();